import React from 'react';

import { initESW } from '../../../utils/liveagent/liveagent_snap_in';
import appConfig from '../../../utils/liveagent/liveagent_config';

export default class ChatComponent extends React.Component {
  render() {
    if (window.embedded_svc) {
      initESW('https://service.force.com');
    }

    return !window.embedded_svc ? (
      <script
        src={appConfig.salesforce.url + '/embeddedservice/5.0/esw.min.js'}
        onLoad={() => initESW(null)}
      />
    ) : null;
  }
}
